import React, {useMemo} from 'react'
import styled from 'styled-components'
import convertUnit from 'lib/unit'
import {ForkygramTemplatePostButtonsItem} from '../ButtonsItem'
import {ForkygramTemplatePostButtonsProps} from './ForkygramTemplatePostButtonsProps'

const StyledContentButtons = styled.div`
  position: absolute;
  right: 0;
  bottom: ${convertUnit(18)};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
`

const StyledMenuContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${convertUnit(8)};
  margin-right: ${convertUnit(8)};
`

export default function ForkygramTemplatePostButtons({
  data,
  onClickMore,
}: ForkygramTemplatePostButtonsProps) {
  const {is_official = false} = data

  const handleRenderMenu = useMemo(
    () => (
      <StyledMenuContainer>
        {!is_official && onClickMore && (
          <ForkygramTemplatePostButtonsItem
            icon="more-filled"
            onClickIcon={onClickMore}
            isOverlay={false}
          />
        )}
      </StyledMenuContainer>
    ),
    [is_official, onClickMore],
  )

  return <StyledContentButtons>{handleRenderMenu}</StyledContentButtons>
}
